import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface KsefCheckDocumentStatusParams {
    documentId: number;
}

export class KsefCheckDocumentStatusCommand extends Command<KsefCheckDocumentStatusParams, void> { }

export class KsefCheckDocumentStatusCommandBase implements CommandHandler<KsefCheckDocumentStatusCommand, KsefCheckDocumentStatusParams, void> {
    private static Url = TaggedUrl.join('eInvoices/:id/checkKsefProcessingState', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(command: KsefCheckDocumentStatusCommand): Promise<void> {
        const url = fillPlaceholders(KsefCheckDocumentStatusCommandBase.Url, { id: command.params?.documentId });
        await this.http.post(url);
    }
}
